import React, {Component} from 'react';
import {connect} from 'react-redux';
import moment from 'moment-timezone';
import Paginate from '../../Common/Paginate';
import {fetchPcBangNotices} from '../../../actions/notices.actions';
import {withRouter} from 'react-router-dom';
import {Table} from '../../Common/PageComponents';

const stateToProps = state => {
  return {
    notices: state.notices,
    totalCount: state.notices.totalCount,
    pageNumber: state.notices.page,
  };
};

class NoticeTable extends Component {
  _movePage(pageNumber) {
    this.props.history.push(`/news/notices/${pageNumber}`);
    this.props.dispatch(fetchPcBangNotices(pageNumber, 10));
  }

  componentDidMount() {
    let currentPageNumber = this.props.match.params.pageNumber;
    if (!currentPageNumber) {
      currentPageNumber = 1;
    }
    this.props.dispatch(fetchPcBangNotices(currentPageNumber, 10));
  }

  _moveToDetail(e, noticeId) {
    e.preventDefault();
    this.props.history.push(`/news/notices/details/${noticeId}`);
  }

  _calculateNoticeDisplayNumber(totalCount, page, index) {
    return (Math.ceil(totalCount / 10) - page - 1) * 10 + (totalCount % 10) + (10 - index);
  }

  render() {
    const notices = this.props.notices;

    return (
      <div>
        <Table>
          <colgroup>
            <col width="78" />
            <col width="*" />
            <col width="118" />
            <col width="102" />
          </colgroup>
          <thead>
            <tr>
              <th>번호</th>
              <th>제목</th>
              <th>작성일</th>
              <th>조회수</th>
            </tr>
          </thead>
          <tbody>
            {notices.data.map((notice, index) => (
              <tr key={notice.noticeId}>
                <td>{this._calculateNoticeDisplayNumber(notices.totalCount, parseInt(notices.page), index)}</td>
                <td style={{textAlign: 'left'}}>
                  <a onClick={e => this._moveToDetail(e, notice.noticeId)}>{notice.title}</a>
                </td>
                <td>
                  {moment
                    .utc(notice.created)
                    .local()
                    .format('YYYY.MM.DD')}
                </td>
                <td>{notice.readCount}</td>
              </tr>
            ))}
          </tbody>
        </Table>
        <Paginate
          currentPage={this.props.pageNumber}
          totalItemCount={this.props.totalCount}
          pageRangeDisplayed={10}
          onChange={this._movePage.bind(this)}
        />
      </div>
    );
  }
}

export default withRouter(connect(stateToProps)(NoticeTable));
